
import { appConfiguration } from '@/store/configuration'
import { defineComponent, ref, computed } from 'vue'
import { request } from '@/store/case'

export default defineComponent({
  setup() {
    const showMenu = ref(false)
    const logoSrc = computed(() => appConfiguration.value?.theme?.logotype?.src || require('../assets/images/logo.png'))
    const hasHelpContent = computed(() => appConfiguration.value?.hasHelpContent)
    const hideHistory = computed(() => appConfiguration.value?.content?.hideHistory || false)
    const logoStyle = computed(() => appConfiguration.value?.theme?.customLogoWidth ? { width: `${appConfiguration.value?.theme?.customLogoWidth}rem` } : false)

    function toggleNav() {
      showMenu.value = !showMenu.value
    }

    function hideMenu() {
      showMenu.value = false
    }

    return {
      logoStyle,
      hideMenu,
      request,
      showMenu,
      toggleNav,
      logoSrc,
      hasHelpContent,
      hideHistory
    }
  }
})
